import itemModalMixin from "@/mixins/item-modal-mixin"

let menuMixin = {
	mixins: [itemModalMixin],
	props: {
		menuTabs: Array,
		itemFilters: Object
	},
	computed: {
		businessName() {
			return this.$store.state.business
				? this.$store.state.business.name
				: ""
		},
		showComingSoon() {
			return (
				this.$store.state.business.is_active == 0 &&
				this.$route.meta.preview != true
			)
		},
		showOffline() {
			return (
				!this.showComingSoon &&
				!this.inStock &&
				this.$route.meta.preview != true
			)
		},
		showMenu() {
			return !this.showOffline && !this.showComingSoon
		},
		loading() {
			return this.$store.state.loading
		},
		loadingMenu() {
			return this.$store.state.loadingMenu
		},
		menu() {
			let items = this.$store.state.menu
			if (this.itemFilters) {
				items = items.filter(menuItem => {
					if (
						this.itemFilters.menuTypes != null &&
						!this.itemFilters.menuTypes.includes(menuItem.menu_type)
					) {
						return false
					}

					if (this.itemFilters.brandId != null) {
						const menu = this.$store.getters.menusHash[
							menuItem.menu_id
						]
							? this.$store.getters.menusHash[menuItem.menu_id]
									.menu
							: null
						if (menu && this.itemFilters.brandId != menu.brand_id) {
							return false
						}
					}
					return true
				})
			}
			return items
		},
		inStock() {
			return this.$store.getters.inStockMenus.length > 0
		},
		isPopup() {
			return this.$store.getters.isPopup
		},
		selectedMenuTab() {
			return this.menuTabs && this.menuTabs.length > 0
				? this.menuTabs.find(tab => tab.selected)
				: null
		}
	},
	methods: {
		trackComingSoon() {
			if (this.showComingSoon) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Coming Soon"
				})
			}
		},
		trackOutOfStock() {
			if (this.showOffline) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Out of Stock"
				})
				this.$store.dispatch(
					"sendForkLiftEvent",
					"app_order_out_of_stock"
				)
			}
		},
		openPreorderOnlyModalIfNeeded() {
			if (this.$store.getters.preorderOnly) {
				const openPreorderOnly =
					this.$store.getters.fullPreorderDate == null
				this.$store.dispatch("setPreorderOnlyDeliverySlot")
				if (openPreorderOnly && this.$refs.timeModal) {
					this.$refs.timeModal.open({
						date: this.$store.state.deliveryDate
					})
				}
			}
		},
		tabClicked(tab) {
			this.$emit("menuTabClicked", tab)
		}
	}
}

export default menuMixin
